// Components
// Libs
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';

import {
  ShowMoreNameDefaultProps,
  ShowMoreNamePropTypes,
} from './ShowMoreName.proptypes';

const ShowMoreName = ({ name, className, context }) => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);

  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () => ['h2', className].filter((val) => val).join(' '),
    [className],
  );

  /**
   * returns the name with a limit of 100 characters
   * @type {string}
   */
  const limitName = useMemo(() => name.substring(0, 100), [name]);

  return (
    <h2
      className={classNames}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...(context ? { 'data-qa-id': context } : null)}
    >
      {showMore ? name : `${limitName}...`}{' '}
      {
        <Button
          className="showmore"
          context="show-more-name"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore
            ? t('common:messages:labels.less')
            : t('common:messages:labels.more')}
        </Button>
      }
    </h2>
  );
};

ShowMoreName.defaultProps = {
  ...ShowMoreNameDefaultProps,
  context: null,
};

ShowMoreName.propTypes = {
  ...ShowMoreNamePropTypes,
  context: PropTypes.string,
};

export default ShowMoreName;
